import React, { useEffect } from 'react';

import { Control, Divider, Grid, GridCol, GridRow, Page, Panel, SettingsItemWrapper } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import validate from 'validators';

import { selectGroupOptions } from './selectors';

function GroupEditFormComponent({
  state,
  onSubmit,
  onDelete,
  values,
  existedGroups,
}) {
  const { t } = useTranslation();
  const isEditState = state === 'edit';
  const formMethods = useForm({ defaultValues: values });
  const { handleSubmit, reset, register, formState: { errors } } = formMethods;

  useEffect(() => { reset(values); }, [reset, values]);

  const onAction = (
    <>
      <Control.Button type="submit">
        {t('lunaStreamsGroups:форма.submit', { context: (state) })}
      </Control.Button>
      {isEditState && (
        <>
          <Divider small />
          <Control.Button
            kind="alert"
            onClick={() => onDelete()}
            type="button"
          >
            {t('lunaStreamsGroups:форма.delete')}
          </Control.Button>
        </>
      )}

    </>
  );
  const context = { ...formMethods };
  return (
    <FormProvider {...context}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Page
          actions={onAction}
          title={t('lunaStreamsGroups:форма.заголовок', { context: (state) })}
        >
          <Divider />
          <Grid>
            <GridRow>
              <GridCol cols={6}>
                <Panel>
                  <SettingsItemWrapper title={t('lunaStreamsGroups:форма.account_id')}>
                    <Control.Input
                      {...register('account_id', {
                        required: validate.required(),
                        validate: validate.uuid(),
                      })}
                      disabled={isEditState}
                      errors={errors}
                    />
                  </SettingsItemWrapper>
                  <SettingsItemWrapper title={t('lunaStreamsGroups:форма.group_name')}>
                    <Control.Input
                      {...register('group_name', {
                        maxLength: validate.maxLength(128),
                        minLength: validate.minLength(1),
                        required: validate.required(),
                        validate: {
                          name: validate.regex(/^[a-zA-Z0-9_\\-]{1,128}$/),
                          unique: (group_name) => (
                            isEditState
                              ? true
                              : group_name && existedGroups.find((g) => g.value === group_name) && t('lunaStreamsGroups:форма.validation.unique', { group_name })
                          ),
                        },
                      })}
                      disabled={isEditState}
                      errors={errors}
                    />
                  </SettingsItemWrapper>
                  <SettingsItemWrapper title={t('lunaStreamsGroups:форма.description')}>
                    <Control.Input
                      {...register('description', {
                        maxLength: validate.maxLength(256),
                      })}
                      errors={errors}
                    />
                  </SettingsItemWrapper>
                </Panel>
              </GridCol>
            </GridRow>
          </Grid>
        </Page>

      </form>
    </FormProvider>
  );
}

GroupEditFormComponent.propTypes = {
  state: PropTypes.oneOf(['create', 'edit']),
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  values: PropTypes.shape({}),
  existedGroups: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};
GroupEditFormComponent.defaultProps = {
  state: 'create',
  values: undefined,
  existedGroups: [],
};

export const GroupEditForm = connect((state) => ({
  existedGroups: selectGroupOptions(state),
}))(GroupEditFormComponent);
